import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPortalFieldsDefs extends Layout {
    sourceRenlgxflds2: DataSource;
    sourceRenlgxflds: DataSource;
    textboxLgxfFldname: Textbox;
    textboxLgxfId: Textbox;
    textboxLgxfLabel: Textbox;
    textboxLgxfTblname: Textbox;
}
